const tickerNameFormat = (ticker = "") => {
  if (ticker?.indexOf(".") === -1) {
    return ticker || "";
  } else {
    return ticker?.slice(0, ticker?.indexOf(".")) || "";
  }
};

export default tickerNameFormat;
